import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-4">
      <div className="text-center">
        <div className="text-6xl font-bold text-primary mb-4">404</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">页面未找到</h1>
        <p className="text-gray-600 mb-8 max-w-md">
          抱歉，您访问的页面不存在或已被移除。请检查URL是否正确，或返回首页。
        </p>
        <div className="space-x-4">
          <Link
            to="/dashboard"
            className="btn-primary inline-flex items-center"
          >
            <i className="fa fa-home mr-2"></i>
            返回首页
          </Link>
          <button
            onClick={() => window.history.back()}
            className="btn-secondary inline-flex items-center"
          >
            <i className="fa fa-arrow-left mr-2"></i>
            返回上一页
          </button>
        </div>
        <div className="mt-12">
          <div className="text-gray-400 text-sm">
            <p>如果您认为这是一个错误，请联系系统管理员。</p>
            <p className="mt-1">错误代码: 404_NOT_FOUND</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;